import axios from 'axios';

const state = {
    settings: null,
    courses: [],
    stats: null,
    enrollments: [],
};

const getters = {
    settings: state => state.settings,
    courses: state => state.courses,
    stats: state => state.stats,
    enrollments: state => state.enrollments,
};

const actions = {
    lms_get_settings(_, shopId) {
        return axios.get('shops/' + shopId + '/lms/settings');
    },
    lms_update_settings(_, { shopId, settings }) {
        return axios.put('shops/' + shopId + '/lms/settings', settings);
    },
    lms_list_courses(_, { shopId, params }) {
        return axios.get('shops/' + shopId + '/lms/courses', { params });
    },
    lms_get_course(_, id) {
        return axios.get('shop/lms/course/' + id);
    },
    lms_create_course(_, { shopId, course }) {
        return axios.post('shops/' + shopId + '/lms/courses', course);
    },
    lms_update_course(_, { id, course }) {
        return axios.put('shop/lms/course/' + id, course);
    },
    lms_delete_course(_, id) {
        return axios.delete('shop/lms/course/' + id);
    },
    lms_list_enrollments(_, { shopId, params }) {
        return axios.get('shops/' + shopId + '/lms/enrollments', { params });
    },
    lms_stats(_, shopId) {
        return axios.get('shops/' + shopId + '/lms/stats');
    },
    lms_mark_paid(_, id) {
        return axios.put('shop/lms/enrollment/' + id + '/mark-paid');
    },
};

const mutations = {
    SET_SETTINGS(state, s) { state.settings = s; },
    SET_COURSES(state, c) { state.courses = c; },
    SET_STATS(state, s) { state.stats = s; },
    SET_ENROLLMENTS(state, e) { state.enrollments = e; },
};

export default { namespaced: true, state, getters, actions, mutations };
